<template>
  <div class="col-12">
    <div class="banner-settings">
      <form v-for="banner in banners" :key="banner.announcement_id">
        <div class="banner-settings__group form-group row align-items-center">
          <label
            for="announcement"
            class="banner-settings__label form-label col-4 col-sm-2 col-form-label"
            >Announcement</label
          >
          <input
            :disabled="!banner.active"
            type="text"
            id="announcement"
            placeholder="Write the announcement here"
            v-model="banner.text"
            class="banner-settings__text form-text col-8 col-sm-10"
          />
        </div>
        <div class="banner-settings__group form-group row align-items-center">
          <label class="banner-settings__label form-label col-4 col-sm-2 col-form-label d-flex"
            >Show banner</label
          >
          <div class="banner-settings__checkbox custom-control custom-checkbox col-4 col-sm-6">
            <input
              class="custom-control-input"
              type="checkbox"
              v-model="banner.active"
              :id="'show-banner' + banner.announcement_id"
              @change="checkboxChanged(banner.announcement_id)"
            />
            <label
              role="button"
              class="custom-control-label"
              :for="'show-banner' + banner.announcement_id"
            ></label>
          </div>
          <div class="banner-settings__buttons col-4 col-sm-4">
            <!-- <button
              class="banner-settings__saveBtn btn btn-primary mb-0"
              @click.prevent="saveBanner(banner)"
            >Save</button>-->
            <button
              class="banner-settings__deleteBtn btn btn-reset btn-sm mb-0"
              title="Remove"
              @click.prevent="deleteBanner(banner)"
            >
              <i class="icon icon-delete text-main"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
    <button class="banner-settings__saveBtn btn btn-primary" @click.prevent="saveBanners">
      Save
    </button>
    <button class="banner-settings__newBtn btn btn-primary" @click.prevent="createBanner">
      New
    </button>
    <span v-if="result" class="banner-settings__resultsAlert alert alert-primary" role="alert">{{
      result
    }}</span>
  </div>
</template>

<script>
import * as api from '@/lib/api'
// Need this "toBoolean" function, didnt exist before ...
String.prototype.toBoolean = function() {
  return String(this.valueOf()).toLowerCase() === true.toString()
}
export default {
  data() {
    return {
      value: false,
      result: '',
      banners: [],
    }
  },
  methods: {
    checkboxChanged(id) {
      console.log('AHA', id)
      this.banners.forEach(function(part, index) {
        if (this[index].announcement_id !== id) this[index].active = false
      }, this.banners) // use this.banners as this inside foreach
    },
    async loadBanners() {
      const response = await api.getBanners()
      // convert string to bool
      this.banners = response.results.map(({ active, ...rest }) => ({
        active: active.toBoolean(),
        ...rest,
      }))
      console.log('BANNERS', { response })
    },
    // async saveBanner(banner) {
    //   this.result = 'Banner saved'
    //   setTimeout(() => this.result = '', 1000)
    //   console.log('SAVING BANNER', banner);
    //   const params = { text: banner.text, active: banner.active }
    //   const response = await api.saveBanner(banner.announcement_id, params)
    //   console.log({ response })
    //   await this.loadBanners()
    // },
    async deleteBanner(banner) {
      this.result = 'Banner deleted'
      setTimeout(() => (this.result = ''), 1000)
      const response = await api.deleteBanner(banner.announcement_id)
      await this.loadBanners()
    },
    async createBanner() {
      this.result = 'Banner created'
      setTimeout(() => (this.result = ''), 1000)
      const response = await api.createBanner({ text: '', active: false })
      await this.loadBanners()
    },
    async saveBanners() {
      this.result = 'Banners saved'
      setTimeout(() => (this.result = ''), 1000)
      this.banners.forEach((banner) => {})
      let responses = []
      for (const banner of this.banners) {
        const params = { text: banner.text, active: banner.active }
        const response = await api.saveBanner(banner.announcement_id, params)
        responses.push(response)
      }
    },
  },
  async mounted() {
    await this.loadBanners()
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/globals';

.banner-settings {
  padding: 20px 30px 18px;
  background: white;
  border-top: 8px solid $pure-teal;
  margin-bottom: 1rem;

  form {
    padding: 10px 24px;
    border-bottom: 1px solid $pure-teal;
  }

  &__checkbox {
    max-width: 18px;
    height: 18px;
  }

  &__deleteBtn {
    margin-bottom: 1rem;
    margin-right: 1rem;
    vertical-align: baseline;
  }

  &__saveBtn {
    margin-right: 1rem;
  }

  &__resultsAlert {
    display: inline-block;
    margin-left: 20px;
    padding: 8px;
  }

  &__buttons {
    padding-top: 10px;
  }

  .custom-checkbox .custom-control-input:checked:focus ~ .custom-control-label::before {
    box-shadow: none;
    border-color: $main;
  }

  .custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none;
    border-color: $main;
  }

  .custom-checkbox .custom-control-input:active ~ .custom-control-label::before {
    background-color: $main;
    border-color: $main;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $main;
    border-color: $main;
  }

  input:focus,
  input:active {
    outline: 0;
  }

  .asset-button {
    padding: 0.3rem 0 0 0;
  }

  .custom-control-label {
    &::before {
      width: 21px;
      height: 21px;
      border: 2px solid $main;
    }

    &::after {
      width: 20px;
      height: 20px;
      color: $main;
    }
  }
}
</style>
